import { callApi } from "../../../../../utils/common/api/callApi";
import { GET_SALE_PAGE_CONTENT_CATALOGUE_API_URL } from "../sale.api.constants";
import { IRecordedContentCatalogueDataFromApi } from "./getRecordedContentCatalogueDataApi.interfaces";

export const callGetRecordedContentCatalogueDataApi = ({
    listingUuid,
}: {
    listingUuid: string;
}) =>
    callApi({
        url: GET_SALE_PAGE_CONTENT_CATALOGUE_API_URL,
        params: { listing_uuid: listingUuid },
        extraOptions: {
            appendAuthHeaders: true,
            appendExlyOriginHeaders: true,
            appendTimezoneHeaders: true,
        },
    }).then((response: any) => {
        const catalogueItemsList: IRecordedContentCatalogueDataFromApi = (
            response?.data?.data?.catalogue || []
        ).map((i: any) => ({
            id: i.uuid,
            title: i.title,
            catalogueItemList: i.sub_categories.map((j: any) => ({
                id: j.uuid,
                title: j.title,
            })),
        }));

        // tags: #test
        // console.log(JSON.stringify(catalogueItemsList));

        return catalogueItemsList;
    });
